"use client";

import adapter from "webrtc-adapter";

const SCRIPT_ID = "janus-js";
const SCRIPT_SRC = "https://cdn.oqylyq.kz/vendor/janus.js";
const TIMEOUT_MS = 8000;

let pending: Promise<boolean> | null = null;

const hasJanus = (): boolean =>
  typeof window !== "undefined" && Boolean((window as unknown as { Janus?: unknown }).Janus);

export function loadJanusScript(): Promise<boolean> {
  if (typeof window === "undefined") return Promise.resolve(false);
  if (hasJanus()) return Promise.resolve(true);
  if (pending) return pending;

  const globalWindow = window as unknown as { adapter?: unknown };
  if (!globalWindow.adapter) globalWindow.adapter = adapter;

  pending = new Promise<boolean>((resolve) => {
    let settled = false;
    const done = (value: boolean) => {
      if (settled) return;
      settled = true;
      if (!value) pending = null;
      resolve(value);
    };

    const existing = document.getElementById(SCRIPT_ID) as HTMLScriptElement | null;
    const script = existing ?? document.createElement("script");

    script.addEventListener("load", () => done(true), { once: true });
    script.addEventListener("error", () => done(false), { once: true });

    if (!existing) {
      script.id = SCRIPT_ID;
      script.src = SCRIPT_SRC;
      script.async = true;
      document.head.appendChild(script);
    }

    setTimeout(() => done(hasJanus()), TIMEOUT_MS);
  });

  return pending;
}
